import React from "react";
import { Col, Row } from "react-bootstrap";
import CommentItem from "./CommentItem";

const DeclarationComments = ({ comments }: { comments: any }) => {
  return (
    <Row style={styles.container}>
      <Col
        xs={12}
        // style={{ padding: "0.5rem 1rem", backgroundColor: "#f1f2f1" }}
      >
        <span
          style={{
            fontFamily: "Saira",
            fontSize: "14px",
            fontWeight: 600,
            textAlign: "left",
          }}
        >
          Comments
        </span>
      </Col>
      {comments?.length > 0 &&
        comments.map((item: any, index: any) => {
          return <CommentItem item={item} key={index} />;
        })}
    </Row>
  );
};

const styles: any = {
  container: {
    backgroundColor: "#f1f2f1",
    paddingLeft: "1.5rem",
  },
  commentsSection: { padding: "0.5rem 1rem 1rem", backgroundColor: "#f1f2f1" },
  pl2: { paddingLeft: "1rem", paddingRight: "1rem" },
  title: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "left",
  },
  value: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
  },
  username: { color: "#000", fontSize: 14, fontWeight: "bold" },
  datetime: { color: "grey", fontSize: 14 },
  remarks: {
    color: "#000",
    fontSize: 14,
  },
  msgHeader: { marginBottom: "2rem" },
  msgBody: {
    borderBottom: "solid",
    borderBottomColor: "lightgrey",
  },
};

export default DeclarationComments;
